<div class="row">
<!-- <div class="row w-100 m-0 p-0 pl-2 pr-2 ml-2 mr-2">
	<div class="float-right">
		Exclusion&nbsp;<mat-slide-toggle [formControl]="selectiontype" (change)="selectionReverse = !selectionReverse"></mat-slide-toggle>&nbsp;Inclusion
	</div>
</div> -->
<div class="card mt-2 col-sm-6">
	<div class="card-body">
			<div class="row">
				<div class="col-12 text-center">
					<button mat-flat-button color="primary" (click)="emitItems()">Select Items</button>
				</div>
				<div class="form-group ml-auto mr-auto col-4">
					<mat-form-field appearance="outline" class="">
						<mat-label>Brand</mat-label>
						<mat-select [formControl]="brand" (selectionChange)="search()" multiple>
							<mat-option *ngFor="let k of brands" [value]="k.manufacturer_id">
								{{ k.name }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="form-group ml-auto mr-auto  col-4">
					<mat-form-field appearance="outline">
						<mat-label>Category</mat-label>
						<mat-select [formControl]="category" multiple="true" (selectionChange)="search()">
							<mat-option *ngFor="let c of categories" [value]="c.categoryid">
								{{ c.categorydescription }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="form-group ml-auto mr-auto col-4">
					<mat-form-field appearance="outline">
						<mat-label>Product Line</mat-label>
						<mat-select [formControl]="productLine" multiple="true" (selectionChange)="search()">
							<mat-option *ngFor="let p of productlines" [value]="p.line_field">
								{{ p.line_description }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

			</div>
			<div class="row">
				<div class="col-md-6 ml-auto mr-auto ">
					<mat-form-field appearance="outline">
						<mat-label>Range Start</mat-label>
						<input autofocus autocomplete="off" aria-hidden="false" matInput [formControl]="rangestart"  value="" class="text-right" (keyup.enter)="$event.preventDefault(); "  (input)="search()">
					</mat-form-field>
				</div>
				<div class="col-md-6 ml-auto mr-auto ">

					<mat-form-field appearance="outline">
						<mat-label>Range End</mat-label>
						<input autofocus autocomplete="off" aria-hidden="false" matInput [formControl]="rangeend"  value="" class="text-right" (keyup.enter)="$event.preventDefault(); "  (input)="search()">
					</mat-form-field>
				</div>
			</div>
			<div class="row">

				<div class="col-md-12">
					<mat-form-field appearance="outline">
						<mat-label>Keywords</mat-label>
						<input autocomplete="off" aria-hidden="false" matInput [formControl]="keywords"  value="" class="text-right" (keyup.enter)="$event.preventDefault();search()">
					</mat-form-field>
				</div>
				<div class="table table-sm  table-fluid container-fluid">
					<h4>
						<ng-container *ngIf="!selectionReverse">Exclusions</ng-container>
						<ng-container *ngIf="selectionReverse">Inclusions</ng-container>
					</h4>
					<table class="table table-fluid table-sm table-striped table bordered" *ngIf="exclusions">
						<thead>
							<tr>
								<th>Item#</th>
								<th>Description</th>
								<th></th>
							</tr>
						</thead>
						<tbody id="exclusions">
							<ng-container *ngIf="exclusions.length > 0">
								<tr *ngFor="let p of exclusions">
									<td>{{ p.stockid }}</td>
									<td>{{ p.description }}</td>
									<td><a class="remove text-danger" (click)="removeExclusion(p)">Remove</a></td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>

			</div>
		</div>
</div>
<div class="card mt-2 col-sm-6">
	<div class="card-body">
		<div class="table table-sm  table-fluid container-fluid" *ngIf="results">
			<h4>
				<ng-container *ngIf="!selectionReverse"> Items Affected </ng-container>
				<ng-container *ngIf="selectionReverse"> Item Results </ng-container>
			</h4>
			
			<table class="table table-fluid table-sm table-striped table bordered">
				<thead>
					<tr>
						<th>Item#</th>
						<th>Description</th>
						<th>DWO</th>
						<th>Discontinued</th>
						<th>QOH</th>
						<th></th>
					</tr>
				</thead>
				<tbody id="mmitems">
					<ng-container >
						<tr *ngFor="let p of results">
							<td>{{ p.stockid }}</td>
							<td>{{ p.description }}</td>
							<td>{{ p.dwo }}</td>
							<td>{{ p.discontinued }}</td>
							<td>{{ p.locstock }}</td>

							<td><a class="remove text-danger" (click)="exludeItem(p)">
								<ng-container *ngIf="selectionReverse">Include</ng-container> 
								<ng-container *ngIf="!selectionReverse">Exclude</ng-container>
							</a></td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>
	</div>
</div>
</div>